export const isZenKatakana =(str)=>{
  str = (str==null)?"":str;
  if(str.match(/^[ァ-ヶー　]+$/)){    //"ー"の後ろの文字は全角スペースです。
    return true;
  }else{
    return false;
  }
}